export default __webpack_public_path__ + "static/media/studies-icon.718f7450.svg";